/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_QuantityInputs */

const vi_report_inventory_quantity = /** @type {(inputs: Report_Inventory_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho`)
};

/**

* @param {Report_Inventory_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_quantity = /** @type {((inputs?: Report_Inventory_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_quantity(inputs)
});